import { PagedResponse } from "@/types/PagedResponse";
import { PageRequest } from "@/types/pagination";
import { Sort } from "@/types/sort";
import { Usuario } from "@/types/usuario";
import { buildFilter } from "@/utils/filter.util";
import axios, { AxiosPromise } from "axios";

export const current = (): AxiosPromise<Usuario> =>
    axios.get(`/api/oauth/current`);

export const getByCodigo = (codigo: string): AxiosPromise<Usuario> => 
    axios.get(`/api/usuario/${codigo}`);    

// Cadastra na corretora atual. E-mail que já tem conta só ganha acesso (a senha não muda);
// conta nova sem senha recebe o e-mail para definir a senha
export const create = (usuario: any): AxiosPromise<Usuario> => 
    axios.post(`/api/usuario`, usuario); 

export const update = (usuario: any, id: string): AxiosPromise<Usuario> => 
    axios.put(`/api/usuario/${id}`, usuario); 

export const autoCompleteAtivo = (search: string): AxiosPromise<PagedResponse<Usuario>> =>
    find(search ? buildFilter(['nome','cpf'])(search) : '',{page: 0, size: 20},{sort: 'nome'});

export const find = (searchParams?: string, pagination?: PageRequest, sort?: Sort): AxiosPromise<PagedResponse<Usuario>> => 
    axios.get(`/api/usuario`, {
        params: {
            search: searchParams,
            ...sort,
            ...pagination
        }
    });

export const remove = (codigo: string): AxiosPromise<void> => 
    axios.delete(`/api/usuario/${codigo}`);     

export const solicitarNovaSenha = (usuario: string): AxiosPromise<any> => 
    axios.post(`/api/usuario/${usuario}/solicitar-nova-senha`); 

export const alterarSenha = (usuario: string, senha: string, senhaTemporaria: boolean): AxiosPromise<void> =>
    axios.put(`/api/usuario/${usuario}/senha`, { senha, senhaTemporaria });

export type Permissoes = { administrador: boolean; permissoes: string[] };

export const getPermissoes = (id: string): AxiosPromise<Permissoes> =>
    axios.get(`/api/usuario/${id}/permissoes`);

export const alterarPermissoes = (id: string, permissoes: string[]): AxiosPromise<Permissoes> =>
    axios.put(`/api/usuario/${id}/permissoes`, permissoes);

export type Aceite = { versao: string; aceitoEm: string };

// Última versão dos termos aceita (204 = ainda não aceitou)
export const getAceite = (id: string): AxiosPromise<Aceite | ''> =>
    axios.get(`/api/usuario/${id}/aceite`);
